import { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { AutoComplete } from '@components/common';
import { fetchCountryList } from '@services/util.service';

interface QuoteCountryFieldProps {
  name: string;
  label: string;
  required?: boolean;
  rootClassName?: string;
}

/**
 * Country dropdown backed by the countries filter-options API (same as supplier address).
 * Form value is an option object ({ label, value }); each payload builder decides
 * whether to send the label or the country code (value).
 */
const QuoteCountryField = ({ name, label, required, rootClassName }: QuoteCountryFieldProps) => {
  const { control, setValue } = useFormContext();
  const [options, setOptions] = useState<any[]>([]);

  const filterCountryOptions = async (event?: any, param: any = null) => {
    const response = await fetchCountryList({ search_text: param });
    setOptions(response?.success ? response.data?.filter_options ?? [] : []);
  };

  useEffect(() => {
    filterCountryOptions();
  }, []);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <AutoComplete
          {...field}
          required={required}
          label={label}
          placeholder="Start typing"
          options={options}
          onInputChange={filterCountryOptions}
          onInputSelection={(event: any, param: any) =>
            setValue(name, param ?? null, { shouldDirty: true, shouldValidate: true })
          }
          keyOption="label"
          error={fieldState.invalid}
          helperText={fieldState.error?.message}
          rootClassName={rootClassName}
        />
      )}
    />
  );
};

export default QuoteCountryField;
